import favoriteStores from './favoriteStores';

export default favoriteStores;
